module.exports = __webpack_public_path__ + "static/media/icon-loader-spinner.2acdb810.svg";